module.exports = __webpack_public_path__ + "static/media/high-left-2.49e2486b.png";